export default __webpack_public_path__ + "static/media/grand-hyat.9112e5a9.jpg";